import Vue from 'vue'
import Router, { Route } from 'vue-router'
import { Store } from 'vuex'
import { StoreState } from '@plugin/Common/interfaces/related-products/store-state.interface'

export default abstract class LocalVue extends Vue {
  public $route: Route

  public $router: Router

  public $store: Store<StoreState>
}
